/**
 * SessionStore - Session-Persistenz für den Multiplayer-Client (sessionStorage)
 * @copyright reDim GmbH | @link https://www.redim.de | @contact team@redim.de
 */

// Session Storage Key (Mirror von MultiplayerClient)
export const SESSION_KEY = 'boomfection_session';

// Session-Gültigkeit: 1 Stunde
export const SESSION_TTL_MS = 60 * 60 * 1000;

/**
 * Kapselt das Speichern/Laden/Löschen der Reconnect-Session.
 * Verhalten identisch zur vorherigen Inline-Implementierung im MultiplayerClient.
 */
export class SessionStore {
    /**
     * @param {string} [key=SESSION_KEY] - sessionStorage-Schlüssel
     * @param {number} [ttlMs=SESSION_TTL_MS] - Gültigkeitsdauer in ms
     */
    constructor(key = SESSION_KEY, ttlMs = SESSION_TTL_MS) {
        this.key = key;
        this.ttlMs = ttlMs;
    }

    /**
     * Session im Storage speichern (nur wenn gameId und playerId gesetzt)
     * @param {string} gameId
     * @param {string} playerId
     */
    save(gameId, playerId) {
        if (gameId && playerId) {
            const session = {
                gameId,
                playerId,
                timestamp: Date.now()
            };
            sessionStorage.setItem(this.key, JSON.stringify(session));
        }
    }

    /**
     * Session aus Storage laden (null wenn abgelaufen oder nicht vorhanden)
     * @returns {{gameId: string, playerId: string, timestamp: number}|null}
     */
    load() {
        try {
            const data = sessionStorage.getItem(this.key);
            if (data) {
                const session = JSON.parse(data);
                // Session max. TTL gültig
                if (Date.now() - session.timestamp < this.ttlMs) {
                    return session;
                }
            }
        } catch (e) {
            console.warn('[MP] Could not load session:', e);
        }
        return null;
    }

    /**
     * Session löschen
     */
    clear() {
        sessionStorage.removeItem(this.key);
    }

    /**
     * Prüft ob eine gültige (nicht abgelaufene) Session existiert
     * @returns {boolean}
     */
    isValid() {
        return this.load() !== null;
    }
}

export default SessionStore;
